import { render, staticRenderFns } from "./IndexAuction.vue?vue&type=template&id=3f75cf80&scoped=true&"
import script from "./IndexAuction.vue?vue&type=script&lang=js&"
export * from "./IndexAuction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f75cf80",
  null
  
)

export default component.exports